import type { CartSchema } from "../client"
interface PriceCalculatorProps {
  cart: CartSchema
}

const PriceCalculator: React.FC<PriceCalculatorProps> = ({ cart }) => {
  const totalPrice = cart.items.reduce(
    (sum, item) => sum + Number(item.price),
    0,
  )
  return <h3>Total: {totalPrice.toFixed(2)}</h3>
}

export default PriceCalculator
